import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../urunDiv.css';
import espresso from '../../../../assets/menu/icecekler/sicak-kahveler/espresso.jpeg';
import doubleEspresso from '../../../../assets/menu/icecekler/sicak-kahveler/double-espresso.jpeg';
import cortada from '../../../../assets/menu/icecekler/sicak-kahveler/cortada.jpeg';
import espressoMacchiato from '../../../../assets/menu/icecekler/sicak-kahveler/espresso-macchiato.jpeg';
import doubleEspressoMacchiato from '../../../../assets/menu/icecekler/sicak-kahveler/double-espresso-macchiato.jpeg';
import espressoConPanna from '../../../../assets/menu/icecekler/sicak-kahveler/espresso-con-panna.jpeg';
import doubleEspressoConPanna from '../../../../assets/menu/icecekler/sicak-kahveler/double-espresso-con-panna.jpeg';
import cafeLatte from '../../../../assets/menu/icecekler/sicak-kahveler/cafe-latte.jpeg';
import cafeLatteMacchiato from '../../../../assets/menu/icecekler/sicak-kahveler/cafe-latte-macchiato.jpeg';
import flatWhite from '../../../../assets/menu/icecekler/sicak-kahveler/flat-white.jpeg';
import cappuccino from '../../../../assets/menu/icecekler/sicak-kahveler/cappuccino.jpeg';
import ristretto from '../../../../assets/menu/icecekler/sicak-kahveler/ristretto.jpeg';
import lungoEspresso from '../../../../assets/menu/icecekler/sicak-kahveler/lungo-espresso.jpeg';
import americano from '../../../../assets/menu/icecekler/sicak-kahveler/americano.jpeg';
import redEye from '../../../../assets/menu/icecekler/sicak-kahveler/red-eye.jpeg';
import cikolataliMocha from '../../../../assets/menu/icecekler/sicak-kahveler/cikolatali-mocha.jpeg';
import beyazCikolataliMocha from '../../../../assets/menu/icecekler/sicak-kahveler/beyaz-cikolatali-mocha.jpeg';
import karamelliMocha from '../../../../assets/menu/icecekler/sicak-kahveler/karamelli-mocha.jpeg';
import zebra from '../../../../assets/menu/icecekler/sicak-kahveler/zebra.jpeg';
import cikitaCoffee from '../../../../assets/menu/icecekler/sicak-kahveler/cikita-coffee.jpeg';
import cheryCheryLady from '../../../../assets/menu/icecekler/sicak-kahveler/chery-chery-lady.jpeg';
import valentinesCoffee from '../../../../assets/menu/icecekler/sicak-kahveler/valentines-coffee.jpeg';
import irishCreamCoffee from '../../../../assets/menu/icecekler/sicak-kahveler/irish-cream-coffee.jpeg';
import baileysCoffee from '../../../../assets/menu/icecekler/sicak-kahveler/baileys-coffee.jpeg';



const SicakKahveler = () => {
  const [selectedKahve, setSelectedKahve] = useState(null);
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const kahveKategorileri = {
    'Sıcak Kahveler': [
      {
        id: 1,
        name: 'Espresso',
        price: '₺159,90',
        image: espresso
      },
      {
        id: 2,
        name: 'Double Espresso',
        price: '₺179,90',
        image: doubleEspresso
      },
      {
        id: 3,
        name: 'Cortada',
        price: '₺199,90',
        image: cortada
      },
      {
        id: 4,
        name: 'Espresso Macchiato',
        price: '₺199,90',
        image: espressoMacchiato
      },
      {
        id: 5,
        name: 'Double Espresso Macchiato',
        price: '₺219,90',
        image: doubleEspressoMacchiato
      },
      {
        id: 6,
        name: 'Espresso Con Panna',
        price: '₺199,90',
        image: espressoConPanna
      },
      {
        id: 7,
        name: 'Double Espresso Con Panna',
        price: '₺219,90',
        image: doubleEspressoConPanna
      },
      {
        id: 8,
        name: 'Cafe Latte',
        price: '₺219,90',
        image: cafeLatte
      },
      {
        id: 9,
        name: 'Cafe Latte Macchiato',
        price: '₺219,90',
        image: cafeLatteMacchiato
      },
      {
        id: 10,
        name: 'Flat White',
        price: '₺219,90',
        image: flatWhite
      },
      {
        id: 11,
        name: 'Cappuccino',
        price: '₺219,90',
        image: cappuccino
      },
      {
        id: 12,
        name: 'Ristretto',
        price: '₺179,90',
        image: ristretto
      },
      {
        id: 13,
        name: 'Lungo Espresso',
        price: '₺179,90',
        image: lungoEspresso
      },
      {
        id: 14,
        name: 'Americano',
        price: '₺189,90',
        image: americano
      },
      {
        id: 15,
        name: 'Red Eye',
        price: '₺224,90',
        image: redEye
      },
      {
        id: 16,
        name: 'Çikolatalı Mocha',
        price: '₺249,90',
        image: cikolataliMocha
      },
      {
        id: 17,
        name: 'Beyaz Çikolatalı Mocha',
        price: '₺249,90',
        image: beyazCikolataliMocha
      },
      {
        id: 18,
        name: 'Karamelli Mocha',
        price: '₺249,90',
        image: karamelliMocha
      }
    ],
    'Sıcak Special Kahveler': [
      {
        id: 19,
        name: 'Zebra',
        price: '₺239,90',
        image: zebra
      },
      {
        id: 20,
        name: 'Çikita Coffee',
        price: '₺239,90',
        image: cikitaCoffee
      },
      {
        id: 21,
        name: 'Chery Chery Lady',
        price: '₺239,90',
        image: cheryCheryLady
      },
      {
        id: 22,
        name: 'Valentine\'s Coffee',
        price: '₺200.00',
        image: valentinesCoffee
      },
      {
        id: 23,
        name: 'Irish Cream Coffee',
        price: '₺239,90',
        image: irishCreamCoffee
      },
      {
        id: 24,
        name: 'Baileys Coffee (alkolsüz)',
        price: '₺239,90',
        image: baileysCoffee
      }
    ]
  };

  const handleKahveClick = (kahve) => {
    if (kahve.name === 'Espresso') {
      navigate('/sicak-kahveler/espresso');
    } else if (kahve.name === 'Double Espresso') {
      navigate('/sicak-kahveler/double-espresso');
    } else if (kahve.name === 'Cortada') {
      navigate('/sicak-kahveler/cortada');
    } else if (kahve.name === 'Espresso Macchiato') {
      navigate('/sicak-kahveler/espresso-macchiato');
    } else if (kahve.name === 'Double Espresso Macchiato') {
      navigate('/sicak-kahveler/double-espresso-macchiato');
    } else if (kahve.name === 'Espresso Con Panna') {
      navigate('/sicak-kahveler/espresso-con-panna');
    } else if (kahve.name === 'Double Espresso Con Panna') {
      navigate('/sicak-kahveler/double-espresso-con-panna');
    } else if (kahve.name === 'Cafe Latte') {
      navigate('/sicak-kahveler/cafe-latte');
    } else if (kahve.name === 'Cappuccino') {
        navigate('/sicak-kahveler/cappuccino');      
      




    } else if (kahve.name === 'Cafe Latte Macchiato') {
      navigate('/sicak-kahveler/cafe-latte-macchiato');
    } else if (kahve.name === 'Flat White') {
      navigate('/sicak-kahveler/flat-white');
    } else if (kahve.name === 'Ristretto') {
      navigate('/sicak-kahveler/ristretto');
    } else if (kahve.name === 'Lungo Espresso') {
      navigate('/sicak-kahveler/lungo-espresso');
    } else if (kahve.name === 'Americano') {
      navigate('/sicak-kahveler/americano');
    } else if (kahve.name === 'Red Eye') {
      navigate('/sicak-kahveler/red-eye');
    } else if (kahve.name === 'Çikolatalı Mocha') {
      navigate('/sicak-kahveler/cikolatali-mocha');
    } else if (kahve.name === 'Beyaz Çikolatalı Mocha') {
      navigate('/sicak-kahveler/beyaz-cikolatali-mocha');
    } else if (kahve.name === 'Karamelli Mocha') {
      navigate('/sicak-kahveler/karamelli-mocha');
    } else if (kahve.name === 'Zebra') {
      navigate('/sicak-kahveler/zebra');
    } else if (kahve.name === 'Çikita Coffee') {
      navigate('/sicak-kahveler/cikita-coffee');
    } else if (kahve.name === 'Chery Chery Lady') {
      navigate('/sicak-kahveler/chery-chery-lady');
    } else if (kahve.name === 'Valentine\'s Coffee') {
      navigate('/sicak-kahveler/valentines-coffee');
    } else if (kahve.name === 'Irish Cream Coffee') {
      navigate('/sicak-kahveler/irish-cream-coffee');
    } else if (kahve.name === 'Baileys Coffee (alkolsüz)') {
      navigate('/sicak-kahveler/baileys-coffee-alkolsuz');
    } else {
      setSelectedKahve(kahve);
    }
  };

  const handleBackToMenu = () => {
    setSelectedKahve(null);
  };

  if (selectedKahve) {
    return <KahveDetay kahve={selectedKahve} onBack={handleBackToMenu} />;
  }

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Sıcak Kahveler</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart"
                  onClick={() => handleKahveClick(kahve)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad">{kahve.name}</h3>
                    <div className="urun-fiyat">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Sıcak Kahveler</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div style={{marginBottom: '80px'}} key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid-computer">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart-computer"
                  onClick={() => handleKahveClick(kahve)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad-computer">{kahve.name}</h3>
                    <div className="urun-fiyat-computer">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default SicakKahveler;
